import Sound from 'views/Sound'

let sound = new Sound()
let sprite
let sprite2
let sprite3
let sprite4
let bg

const DEVIATION_X=0.015
const DEVIATION_Y=19
const DEVIATION_Z=990

class Music {
    constructor() {
        this.init()
    }

    init() {
        // 文件1
        this.file = {
            src: ['static/sounds/all1.mp3'],
            sprite: {
                s1_bird1: [0, 4875, true], // 鸟叫声1
                s1_qi: [5321, 426, true], // 脚步
                s1_dajie: [6011, 17463, true], // 马路音效
                s1_Bicycle: [23555, 2153, true], // 自行车铃声
                s1_clock: [25972, 1868, true], // 钟表
                s1_macar: [28389, 2291, true], // 马车
                s1_Motorcycle: [31147, 9445], // 摩托车
                s1_bird2: [42066, 345, true], // 鸟叫声2
                s1_qq: [42513, 771, true], // qq提醒
                s1_Bus: [43386, 386, false], // 汽车鸣笛
                s1_Seawave: [43833, 4874, true], // 海浪
                s1_Seagull: [48768, 2904, true] // 海鸥
            },
            volume: 0
        }
        this.music_place = [
            {x: -0.8001 ,y: 1.444 ,z: 1000, name: 's1_bird1', vol: 1},
            {x: -4.7069 ,y: 2.0694 ,z: 1000, name: 's1_qi', vol: 1},
            {x: -4.6777 ,y: 1.9525 ,z: 1000, name: 's1_dajie', vol: 1},
            {x: 0.6218 ,y: 1.9525 ,z: 1000, name: 's1_Bicycle', vol: 1},
            {x: 12.9196 ,y: 2.1472 ,z: 1000, name: 's1_clock', vol: 1},
            // {x: -4.3232 ,y: 1.9565 ,z: 1000, name: 's1_macar', vol: 1},
            {x: -9.8685 ,y: 0.7126 ,z: 2000, name: 's1_Motorcycle', vol: 1},
            // {x: 6727.691, y: -2.55, z: -8.229, name: 's1_bird1', vol: 1},
            {x: -15.3574 ,y: 0.1558 ,z: 3000, name: 's1_qq', vol: 1},
            {x: -5.8767 ,y: 0.5108 ,z: 3000, name: 's1_Bus', vol: 1},
            {x: -9.5145 ,y: 0 ,z: 4000, name: 's1_Seawave', vol: 1},
            {x: -9.7872 ,y: 0.0389 ,z: 4000, name: 's1_Seagull', vol: 1}
        ]

        // 文件2
        this.file2 = {
            src: ['static/sounds/all2.mp3'],
            sprite: {
                child: [0, 7399, true], // 唐僧被抓走了
                oldman: [8000, 7000, true], // 5分钱1根
                gongxi: [17000, 5000, true], // 王总，恭喜发财
                hunsha: [24000 , 7000 , true], // 我们看看这家婚纱
                girl: [32000, 6000, true], // 妈妈我想喝可乐汽水
                Cashier: [38000, 7000, true], // 这是您要的学习机
                QQshow: [46000, 7000, true], // 你这套qq秀
                zuoti: [54000, 5100, true], // 老大这道题怎么做
                SharedBicycle: [60000, 5300, true], // 妈给我刷一辆共享单车
                Rope: [66000, 6000, true], // 花线游戏
                // Shenzhou4047: [73000, 14000, true], // 神州发射
                Shenzhou2: [88500, 15000, true] // 杨利伟发言


                // child: [0, 3439, true], // 唐僧被抓走了
                // oldman: [4585, 3439, true], // 5分钱1根
                // gongxi: [9973, 2006, true], // 王总，恭喜发财
                // hunsha: [13355, 3184, true], // 我们看看这家婚纱
                // girl: [17425, 2348, true], // 妈妈我想喝可乐汽水
                // Cashier: [21437, 3450, true], // 这是您要的学习机
                // QQshow: [25163, 3611, true], // 你这套qq秀
                // zuoti: [30264, 2800, true], // 老大这道题怎么做
                // SharedBicycle: [34105, 2407, true], // 妈给我刷一辆共享单车
                // Rope: [37372, 3231, true], // 花线游戏
                // Shenzhou4047: [40999, 7539, true], // 神州发射
                // Shenzhou2: [48758, 7985, true] // 杨利伟发言
            },
            volume: 0
        }
        this.music_place2 = [
            {x: 7.0616 ,y: 1.6468 ,z: 1000, name: 'child', vol: 1},
            {x:-1.5026 ,y: 1.6858 ,z: 1000, name: 'oldman', vol: 1},
            {x: -2.2013 ,y: 0.818 ,z: 2000, name: 'gongxi', vol: 1},
            {x: -14.0266 ,y: 2.3031 ,z: 1000, name: 'hunsha', vol: 1},
            {x: -7.5282 ,y: 0.2337 ,z: 2000, name: 'girl', vol: 1},
            {x: 6.0063 ,y: 0.082 ,z: 2000, name: 'Cashier', vol: 1},
            {x: -10.5591 ,y: 0.4673 ,z: 3000, name: 'QQshow', vol: 1},
            {x: 4.4392 ,y: 0.5843 ,z: 3000, name: 'zuoti', vol: 1},
            {x: -4.0995 ,y: 1.1604 ,z: 4000, name: 'SharedBicycle', vol: 1},
            {x: -4.6777 ,y: 1.9525 ,z: 1000, name: 'Rope', vol: 1},
            {x: -13.9552 ,y: 0.0778 ,z: 2000, name: 'Shenzhou4047', vol: 1},
            {x: -11.096 ,y: 0.4719 ,z: 3000, name: 'Shenzhou2', vol: 1}
        ]

        // 文件3
        this.file3 = {
            src: ['static/sounds/all3.mp3'],
            sprite: {
                zhongba: [0, 15000, true], // 中巴铁路
                blogger: [16000, 15000, true], // 主播直播，新来的宝宝们
                business: [31000, 9000, true], // 这次回去我就辞职创业
            },
            volume: 0
        }
        this.music_place3 = [
            {x: -4.296 ,y: 0.0389 ,z: 4000, name: 'blogger', vol: 1},
            {x: 4.6081 ,y: 1.1993 ,z: 4000, name: 'zhongba', vol: 1},
            {x: 12.7595 ,y: 0.9267 ,z: 4000, name: 'business', vol: 1},
        ]
        // 文件4
        this.file4 = {
            src: ['static/sounds/all3.mp3'],
            sprite: {},
            volume: 0
        }
        this.music_place4 = []
        // 背景音乐
        this.bg = {
            src: ['static/sounds/bg.mp3'],
            sprite: {
                s1_bg: [33066, 9526, true],
                s2_bg: [14778, 17934, true],
                s3_bg: [0, 14439, true],
                s4_bg: [57833, 54253, true],
                s5_bg: [43101, 14304, true]
            },
            volume: 0
        }
        this.music_status = []
        sprite = sound.init(this.file)
        sprite2 = sound.init(this.file2)
        sprite3 = sound.init(this.file3)
        sprite4 = sound.init(this.file4)
        bg = sound.init(this.bg)
        let playing = false
        let btn = document.getElementsByClassName('rot2')
        bg.once('load', function () {
            // console.log('loadeddd')
            playing = true
            //  一开始没有动画。到这一刻开始动画
            btn[0].className = 'rot2 rot_'
        })
        document.getElementById('music_btn').onclick = function () {
            // console.log('hahahaha')
            if (playing === true) {
                // console.log('停了他')
                sound.mutesound()
                playing = false
                btn[0].className = 'rot2'
            } else {
                sound.unmutesound()
                playing = true
                btn[0].className = 'rot2 rot_'
            }
        }
        for (let i in this.music_place) {
            let mx = this.music_place[i].x
            let my = this.music_place[i].y
            let mz = this.music_place[i].z
            let mn = this.music_place[i].name
            let mv = this.music_place[i].vol
            sound.play(mx, my, mz, mn, mv, sprite)
        }
        for (let i in this.music_place2) {
            let mx = this.music_place2[i].x
            let my = this.music_place2[i].y
            let mz = this.music_place2[i].z
            let mn = this.music_place2[i].name
            let mv = this.music_place2[i].vol
            sound.play(mx, my, mz, mn, mv, sprite2)

        }
        for (let i in this.music_place3) {
            let mx = this.music_place3[i].x
            let my = this.music_place3[i].y
            let mz = this.music_place3[i].z
            let mn = this.music_place3[i].name
            let mv = this.music_place3[i].vol
            sound.play(mx, my, mz, mn, mv, sprite3)

        }
    }

    jingyin () {
        // sound.mutesound()
        sprite.volume(0)
        sprite2.volume(0)
        sprite3.volume(0)
        sprite4.volume(0)
    }

    playmusic(x, y, z) {
        sound.position(x, y, z)
        // for (let i in this.music_place) {
        //     let mx = this.music_place[i].x
        //     let my = this.music_place[i].y
        //     let mz = this.music_place[i].z
        //     let mn = this.music_place[i].name
        //     let mv = this.music_place[i].vol
        //     // let _arr = []
        //     if (Math.abs(x - mx) <= DEVIATION_X && Math.abs(y - my) <= DEVIATION_Y && Math.abs(z - mz) <= DEVIATION_Z) {
        //         if (this.music_status.indexOf(mn) === -1) {
        //             sound.play(mx, my, mz, mn, mv, sprite)
        //             this.music_status.push(mn)
        //         }
        //     }
        //     if (Math.abs(x - mx) > DEVIATION_X*1.5 || Math.abs(y - my) > DEVIATION_Y*1.5) {
        //         for (let ii in this.music_status) {
        //             if (this.music_status[ii] === mn && this.music_status.indexOf(mn) > -1) {
        //                 this.music_status.splice(ii, 1)
        //             }
        //         }
        //     }
        // }
        // for (let i in this.music_place2) {
        //     let mx = this.music_place2[i].x
        //     let my = this.music_place2[i].y
        //     let mz = this.music_place2[i].z
        //     let mn = this.music_place2[i].name
        //     let mv = this.music_place2[i].vol
        //     // let _arr = []
        //     if (Math.abs(x - mx) <= DEVIATION_X && Math.abs(y - my) <= DEVIATION_Y && Math.abs(z - mz) <= DEVIATION_Z) {
        //         if (this.music_status.indexOf(mn) === -1) {
        //             sound.play(mx, my, mz, mn, mv, sprite2)
        //             this.music_status.push(mn)
        //         }
        //     }
        //     if (Math.abs(x - mx) > DEVIATION_X*1.5 || Math.abs(y - my) > DEVIATION_Y*1.5) {
        //         for (let ii in this.music_status) {
        //             if (this.music_status[ii] === mn && this.music_status.indexOf(mn) > -1) {
        //                 this.music_status.splice(ii, 1)
        //             }
        //         }
        //     }
        // }
        // for (let i in this.music_place3) {
        //     let mx = this.music_place3[i].x
        //     let my = this.music_place3[i].y
        //     let mz = this.music_place3[i].z
        //     let mn = this.music_place3[i].name
        //     let mv = this.music_place3[i].vol
        //     // let _arr = []
        //     if (Math.abs(x - mx) <= DEVIATION_X && Math.abs(y - my) <= DEVIATION_Y && Math.abs(z - mz) <= DEVIATION_Z) {
        //         if (this.music_status.indexOf(mn) === -1) {
        //             sound.play(mx, my, mz, mn, mv, sprite3)
        //             this.music_status.push(mn)
        //         }
        //     }
        //     if (Math.abs(x - mx) > DEVIATION_X*1.5 || Math.abs(y - my) > DEVIATION_Y*1.5) {
        //         for (let ii in this.music_status) {
        //             if (this.music_status[ii] === mn && this.music_status.indexOf(mn) > -1) {
        //                 this.music_status.splice(ii, 1)
        //             }
        //         }
        //     }
        // }
    }

    startmusic(name) {
        let id = sound.startloop(name, bg)
        return id
    }

    stopmusic(id) {
        sound.stoploop(bg)
    }
}

export default Music



// WEBPACK FOOTER //
// ./src/js/views/MusicControl.js